import React from 'react';
import usePageTitle from 'app/hooks/usePageTitle';
import LogoIcon from 'app/fuse-layouts/shared-components/LogoIcon';

const FuseSplashScreen = () => {
	usePageTitle('Loading...');

	return (
		<div id="fuse-splash-screen">
			<div className="center">
				<div className="logo">
					<LogoIcon width="128" />
				</div>
				<div className="spinner-wrapper">
					<div className="spinner">
						<div className="inner">
							<div className="gap" />
							<div className="left">
								<div className="half-circle" />
							</div>
							<div className="right">
								<div className="half-circle" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(FuseSplashScreen);
